export default __webpack_public_path__ + "static/media/Group 44_2.68aa23ad.svg";